import { investmentInitialValue } from "@/types/app/investment";
import { notificationInitialValue } from "@/types/app/notifications";
import { schedulesInitialValue } from "@/types/app/schedules";

export default {
  customers: [],
  refuseds: [],
  customer: {
    scheduleIndexResponse: {
      bookingPage: {},
    },
  },
  loading: true,
  modalCustomer: false,
  modalInterest: false,
  modalCreateInterest: false,
  modalImportInterest: false,
  modalAccountMirror: false,
  modalRefused: false,
  modalRefuse: false,
  undoRefused: false,
  modalMessage: false,
  modalNotification: false,
  modalJobInfo: false,
  modalInvestment: false,
  modalNewNotification: false,
  notificationSent: false,
  ModalDeleteState: false,
  investment: investmentInitialValue,
  notification: notificationInitialValue,
  notifications: [],

  schedule: schedulesInitialValue,
  modalSchedule: false,
  scheduleFeedbackModal: false,
};
